import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useCommonStore = defineStore('common', () => {
  const announcementList = ref(null)
  const broadcastList = ref(null)
  const mailBoxInfo = ref(null)
  const defaultAffiliateCode = ref(null)

  function setAnnouncementList(data) {
    announcementList.value = data
  }

  function clearAnnouncementList() {
    announcementList.value = null
  }

  function setBroadcastList(data) {
    broadcastList.value = data
  }

  function clearBroadcastList() {
    broadcastList.value = null
  }

  function setMailBoxInfo(data) {
    mailBoxInfo.value = data
  }

  function clearMailBoxInfo() {
    mailBoxInfo.value = null
  }

  function $reset() {
    announcementList.value = null
    broadcastList.value = null
    mailBoxInfo.value = null
  }

  function setDefaultAffiliateCode(code) {
    defaultAffiliateCode.value = code
  }
  return {
    announcementList,
    broadcastList,
    mailBoxInfo,
    setAnnouncementList,
    clearAnnouncementList,
    setBroadcastList,
    clearBroadcastList,
    setMailBoxInfo,
    clearMailBoxInfo,
    $reset,
    defaultAffiliateCode,
    setDefaultAffiliateCode,
  }
})
